import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {

  ngOnInit(): void {
  }

  @Input() title = 'Confirm Action';
  @Input() message = 'Are you sure you want to do this? This action can not be undone later.';
  @Input() confirmLabel = 'YES';
  @Input() cancelLabel = 'NO';

  constructor(protected dialogRef: NbDialogRef<ConfirmDialogComponent>) {}

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }

}
